import * as angular from "angular";
import * as _ from "lodash";
import * as moment from "moment";
import {SapDocumentType} from "../types/sap-document.type";
import {BillingAccountsRequests} from "./billing-accounts-requests.service";
import {BillingAlertsService} from "./billing-alerts.service";
import {PhoneAndEmailFactoryService} from "../../commons/services/phone-and-email-factory.service";

export class BillingAccountDialogService {

  public SapDocumentTypes = Object.values(SapDocumentType);

  constructor(private $mdDialog, private billingAccountsRequests: BillingAccountsRequests, private $log, private billingAccountConstants,
              private $billingAccounts, private billingAlertsService: BillingAlertsService, private splitService) {
  }

  editBillingContact(billingAccount, index) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialog-views/billing-account-details-dialog.html').default,
      controller: function ($scope, phoneAndEmailFactoryService: PhoneAndEmailFactoryService) {

        const country = self.splitService.getCountryCode();
        $scope.submitted = false;
        $scope.header = 'Edit Recipient';
        $scope.loading = false;
        $scope.isEditMode = true;
        $scope.billingAccount = angular.copy(billingAccount);
        $scope.billingContactIndex = index;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onPhoneChange = (phoneNumber, form) => {
          phoneAndEmailFactoryService.phoneFormValidation(phoneNumber, country, form, 'phone');
        }

        $scope.deleteRecipient = () => {
          $scope.billingAccount.billingContacts.splice($scope.billingContactIndex, 1);
          self.$mdDialog.hide($scope.billingAccount);
        }

        $scope.submit = (form) => {
          if (form.$valid) {
            // if (!_.get($scope.billingAccount, 'billingContacts')) {
            //   $scope.billingAccount.billingContacts = [];
            // }
            self.$mdDialog.hide($scope.billingAccount);
          } else {
            form.$setSubmitted(true);
          }
        }

      },
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  editBillingAccountSettings(billingAccount) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialog-views/edit-billing-account-settings-dialog.html').default,
      controller: function ($scope) {

        $scope.submitted = false;
        $scope.loading = false;
        $scope.billingAccountTypes = self.billingAccountConstants.types;
        $scope.chargingTerms = self.billingAccountConstants.chargingTerms;
        $scope.currencySymbol = self.splitService.getCurrencySymbol();
        $scope.billingAccount = angular.copy(billingAccount);

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onAddressChange = (address) => {
          $scope.billingAccount.billingAddress = address;
        }

        $scope.submit = (form) => {
          if (form.$valid) {
            self.$mdDialog.hide($scope.billingAccount);
          } else {
            form.$setSubmitted(true);
          }
        }

      },
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  addBillingContact(billingAccount) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialog-views/billing-account-details-dialog.html').default,
      controller: function ($scope, phoneAndEmailFactoryService: PhoneAndEmailFactoryService) {

        const country = self.splitService.getCountryCode();
        $scope.submitted = false;
        $scope.loading = false;
        $scope.header = 'Create New Recipient';
        $scope.billingAccount = angular.copy(billingAccount);
        if (!_.get($scope.billingAccount, 'billingContacts')) {
          $scope.billingAccount.billingContacts = [];
        }
        $scope.billingContactIndex = $scope.billingAccount.billingContacts.length;
        $scope.billingAccount.billingContacts[$scope.billingContactIndex] = {
          name: '',
          phone: '',
          email: ''
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onPhoneChange = (phoneNumber, form) => {
          phoneAndEmailFactoryService.phoneFormValidation(phoneNumber, country, form, 'phone');
        }

        $scope.submit = (form) => {
          if (form.$valid) {
            // if (!_.get($scope.billingAccount, 'billingContacts')) {
            //   $scope.billingAccount.billingContacts = [];
            // }
            self.$mdDialog.hide($scope.billingAccount);
          } else {
            form.$setSubmitted(true);
          }
        }

      },
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  editBillingAccount(event, billingAccount) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/edit-billing-account-dialog.tmpl.html').default,
      controller: function ($scope) {

        $scope.submitted = false;
        $scope.loading = false;
        $scope.billingAccountTypes = self.billingAccountConstants.types;
        $scope.billingAccount = angular.copy(billingAccount);

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.submit = (form) => {

          if (form.$valid) {

            if (billingAccount) {

              $scope.submitted = true;
              $scope.loading = true;

              self.$billingAccounts(billingAccount.id).$post($scope.billingAccount)
                .then((updated) => {
                  $scope.loading = false;
                  $scope.billingAccount = updated;
                  self.billingAlertsService.updateBillingAccountSuccess();
                  self.$mdDialog.hide();
                })
                .catch(() => {
                  self.billingAlertsService.updateBillingAccountError();
                  $scope.submitted = false;
                  $scope.loading = false;
                })

            } else {
              self.$log.error('Billing account resolved to undefined!. \n ' +
                '--> editBillingAccount@submitForm');
            }

          } else {
            form.$setSubmitted(true);
          }

        }

      },
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  createInvoice(event, orderIds, billingAccount?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/create-invoice-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.chargingTerms = self.billingAccountConstants.chargingTerms;
        $scope.selectedChargingTerms = _.get(billingAccount, 'chargingTerms', $scope.chargingTerms[0]);

        $scope.billingAccount = billingAccount;
        // $scope.emails = [];

        $scope.orderIdChips = _.map(orderIds, (id) => {
          return {name: id};
        });


        $scope.emailChips = _.map(_.get(billingAccount, 'billingContacts', []), billingContact => {
          return {name: billingContact.email}
          // $scope.emails.push({name: billingContact.email});
        });

        $scope.invoice = {
          billingAccountId: undefined,
          billingOrderIds: [],
          dueDate: undefined,
          note: undefined,
          emailRecipients: []
        };


        $scope.onChangeChargingTerms = (selectedChargingTerms) => {
          $scope.selectedChargingTerms = selectedChargingTerms;

          let daysToAdd = 0;

          switch (selectedChargingTerms) {
            case 'Net10': {
              daysToAdd = 10;
              break;
            }
            case 'Net15': {
              daysToAdd = 15;
              break;
            }
            case 'Net30': {
              daysToAdd = 30;
              break;
            }
            case 'Net60': {
              daysToAdd = 60;
              break;
            }
            default: {
              break;
            }
          }

          $scope.invoice.dueDate = moment().add(daysToAdd, 'day').startOf('day').valueOf();
        }

        $scope.onChangeChargingTerms($scope.selectedChargingTerms);


        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onEmailListChange = (list) => {
          $scope.emailChips = list;
        }

        $scope.onDateChange = (selectedDate) => {
          $scope.invoice.dueDate = selectedDate;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              $scope.invoice.billingOrderIds = _.map($scope.orderIdChips, 'name');
              $scope.invoice.emailRecipients = _.map($scope.emailChips, 'name');
              self.$mdDialog.hide($scope.invoice);
            }
          }
        }

      }
    })
  }


  deleteInvoice(event, billingOrder) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/delete-invoice-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.billingOrderEmailRecipients = billingOrder.emailRecipients;
        $scope.cancel = self.$mdDialog.cancel;
        $scope.onSubmit = self.$mdDialog.hide;
        /////////////////////////////////////////////////////////////////

        // $scope.onSubmit = () => {
        //   this.$mdDialog.hide();
        // }

      }
    })
  }

  consolidateBillingOrders(billingOrders?, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/consolidate-billing-order-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {
        const today = moment().valueOf();

        $scope.name = undefined;
        $scope.comment = undefined;
        $scope.billTo =  _.get(billingOrders, '[0].billingAccountReference.accountingName');
        $scope.billingCycle = self.splitService.getAccountBillingCycle();
        $scope.docDate = ($scope.billingCycle?.from && $scope.billingCycle?.to) ?
          _getDocDateByCycle($scope.billingCycle.from, $scope.billingCycle.to) :
          ($scope.billingCycle?.from ? $scope.billingCycle.from : moment().valueOf());
        $scope.selectedConsolidatedBillingOrder = undefined;
        $scope.isCreateNewConsolidate = true;
        $scope.billingOrdersChips = _.map(billingOrders, (b) => {
          return {name: b.name || b.id, id: b.id};
        })
        $scope.billingAccountIds = _.uniq(_.flatMap(billingOrders, 'billingAccountId'));

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onChangeMode = (isCreateNewConsolidate) => {
          $scope.isCreateNewConsolidate = isCreateNewConsolidate;
          $scope.selectedConsolidatedBillingOrder = undefined;
        }

        $scope.onNameChange = (name) => {
          $scope.name = name;
        }

        $scope.onCommentChange = (comment) => {
          $scope.comment = comment;
        }

        $scope.onBillToChange = (billTo) => {
          $scope.billTo = billTo;
        }

        $scope.onDateChange = (selectedDate) => {
          $scope.docDate = selectedDate;
        }

        $scope.onConsolidatedBillingOrderSelect = (consolidatedBillingOrder) => {
          $scope.selectedConsolidatedBillingOrder = consolidatedBillingOrder;
        }

        $scope.onRemoveChip = (chip) => {

        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const payload = {
                name: $scope.name,
                docDate: $scope.docDate,
                billTo: $scope.billTo,
                comment: $scope.comment,
                consolidatedId: _.get($scope.selectedConsolidatedBillingOrder, 'id'),
                add: _.map($scope.billingOrdersChips, 'id'),
                remove: []
              }
              self.$mdDialog.hide(payload)

            }
          }
        }

        function _getDocDateByCycle(from: number, to: number) {
          const today = moment().valueOf();
          const isBetween = moment(today).isBetween(from, to, null, '[]');
          // return isBetween ? today : to;
          return isBetween ? today : (today <= from ? from : to);
        }

      }
    })
  }

  addBillingOrdersToConsolidatedOrder(billingAccountId, billingOrdersToAdd?, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/add-billing-orders-to-consolidated-order-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.queryString = undefined;
        $scope.fromDate = moment().startOf('month').valueOf();
        $scope.toDate = moment().endOf('month').valueOf();
        $scope.selectedBillingOrders = [];
        $scope.billingAccountIds = [billingAccountId];
        $scope.tableSettings = self.splitService.getSiteBillingOrdersSettings();

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onQueryStringChange = (query) => {
          $scope.queryString = query;
        }

        $scope.onFromChange = (selectedDate) => {
          $scope.fromDate = selectedDate;
        }

        $scope.onToChange = (selectedDate) => {
          $scope.toDate = selectedDate;
        }

        $scope.onSelectedBillingOrdersChange = (billingOrders) => {
          $scope.selectedBillingOrders = billingOrders;
        }

        $scope.onSubmit = () => {
          self.$mdDialog.hide(_.map($scope.selectedBillingOrders, 'id'));
        }


      }
    })
  }

  editConsolidatedBillingOrder(consolidatedBillingOrder, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/edit-consolidated-billing-order-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.consolidatedBillingOrder = angular.copy(consolidatedBillingOrder);
        $scope.billingOrdersChips = _.map(consolidatedBillingOrder.billingOrderReferences, ((b) => {
          return {name: b.name || b.id, id: b.id};
        }))
        $scope.billingCycle = self.splitService.getAccountBillingCycle();

        $scope.cancel = self.$mdDialog.cancel;


        $scope.onNameChange = (name) => {
          $scope.consolidatedBillingOrder.name = name;
        }

        $scope.onCommentChange = (comment) => {
          $scope.consolidatedBillingOrder.comment = comment;
        }

        $scope.onBillToChange = (billTo) => {
          $scope.consolidatedBillingOrder.billTo = billTo;
        }

        $scope.onDateChange = (selectedDate) => {
          $scope.consolidatedBillingOrder.docDate = selectedDate;
        }

        $scope.onRemoveChip = (chip) => {
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const payload = {
                name: $scope.consolidatedBillingOrder.name,
                docDate: $scope.consolidatedBillingOrder.docDate,
                billTo: $scope.consolidatedBillingOrder.billTo,
                comment: $scope.consolidatedBillingOrder.comment,
              }
              self.$mdDialog.hide(payload)

            }
          }
        }


      }
    })
  }

  editConsolidatedBillingOrdersDate(docDate?, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/edit-consolidated-billing-orders-date-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.docDate = docDate || moment().valueOf();
        $scope.cancel = self.$mdDialog.cancel;

        $scope.onDateChange = (selectedDate) => {
          $scope.docDate = selectedDate;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.docDate);
            }
          }
        }


      }
    })
  }

  refundConsolidatedBillingOrder(consolidatedBillingOrder, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/refund-consolidated-billing-order.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.consolidatedBillingOrder = angular.copy(consolidatedBillingOrder);
        $scope.totalExistingRefund = _.reduce(consolidatedBillingOrder.refundInfos, (sum: any, refundData) => {
          return sum + (refundData?.refundAmount || 0);
        }, 0);
        $scope.maxAmountToRefund = (consolidatedBillingOrder.totalPrice - $scope.totalExistingRefund);

        $scope.payload = {
          refundAmount: undefined,
          comment: undefined,
          dueDate: moment().startOf('day').valueOf()
        }

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        // $scope.onRefundAmountChange = (refundAmount) => {
        //   $scope.payload.refundAmount = refundAmount;
        // }

        // $scope.onCommentChange = (comment) => {
        //   $scope.payload.comment = comment;
        // }

        $scope.onDueDateChange = (dueDate) => {
          $scope.payload.dueDate = dueDate;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              if ($scope.payload.refundAmount <= 0) {
                self.billingAlertsService.notZeroInfo();
                return;
              }

              self.$mdDialog.hide($scope.payload);
            }
          }
        }


      }
    })
  }

  selectPdfTemplate(event?, enableIncludeEmptyPrices?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/select-pdf-template-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.enableIncludeEmptyPrices = enableIncludeEmptyPrices;
        $scope.pdfTemplate = "Default";
        $scope.includeEmptyPrices = {
          enabled: false
        };

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onChange = (pdfTemplate) => {
          $scope.pdfTemplate = pdfTemplate;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({pdfTemplate: $scope.pdfTemplate, includeEmptyPrices: enableIncludeEmptyPrices ? $scope.includeEmptyPrices.enabled : undefined});
            }
          }
        }


      }
    })
  }

  selectSapDocumentType(event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/select-sap-document-type-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.sapDocumentTypes = self.SapDocumentTypes;
        $scope.selectedDocumentType = self.SapDocumentTypes[0];

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onChange = (SapDocumentType: SapDocumentType) => {
          $scope.selectedDocumentType = SapDocumentType;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.selectedDocumentType);
            }
          }
        }


      }
    })
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .service('billingAccountDialogService', BillingAccountDialogService);
